import { useMutation } from "@apollo/client/react";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";
import { UPDATE_INVOICE_ISSUER } from "../../mutations/invoices/updateInvoiceIssuer";

export const useUpdateInvoiceIssuer = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [updateInvoiceIssuer, { data, loading, error }] = useMutation(
    UPDATE_INVOICE_ISSUER,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: noRefetch ? [] : [GET_INVOICE_LATEST_VALIDATION_RESULT],
      awaitRefetchQueries: true,
    },
  );

  return { updateInvoiceIssuer, data, loading, error };
};
